import { createMuiTheme as createTheme } from '@material-ui/core/styles';
import createBreakpoints from '@material-ui/core/styles/createBreakpoints';

const defaultTheme = createTheme();

export const createMuiTheme = (secondaryColor) =>
  createTheme({
    breakpoints: {
      keys: ['xxs', 'xs', 'sm', 'md', 'lg', 'xl'],
      values: { xxs: 0, xs: 360, sm: 600, md: 960, lg: 1280, xl: 1920 },
    },

    customBreakpoints: createBreakpoints({
      keys: ['sm1', 'md1', 'lg1'],
      values: {
        sm1: 720,
        md1: 1024,
        lg1: 1440,
      },
    }),

    overrides: {
      MuiDialogTitle: {
        root: {
          backgroundColor: '#383838',
          color: '#fff',
          fontSize: '1.15em',
          fontWeight: 'bold',
          padding: '10px 15px',
        },
      },
      MuiIconButton: {
        root: {
          color: '#36333E',
        },
      },
      MuiListItemIcon: {
        root: {
          fill: '#36333E',
          marginRight: 0,
        },
      },
      MuiListItemText: {
        inset: {
          '&:first-child': {
            paddingLeft: defaultTheme.spacing.unit * 5,
          },
        },
      },
      MuiFormLabel: {
        root: {
          color: '#3d3d3d',
          '&$focused': {
            color: '#3D3D3D',
          },
        },
      },
      MuiInput: {
        underline: {
          '&:after': {
            borderBottom: '2px solid #3D3D3D',
          },
        },
      },
      MuiLinearProgress: {
        barColorPrimary: {
          backgroundColor: '#FFFFFF',
          borderRadius: 3,
          height: 6,
        },
        colorPrimary: {
          backgroundColor: '#323232',
          borderRadius: 3,
          height: 6,
        },
      },
      MuiBottomNavigationAction: {
        root: {
          color: '#A8A8A8',
          '&$selected': {
            color: '#FFFFFF',
            '& svg': {
              color: '#FFFFFF',
            },
          },
        },
      },
    },
    palette: {
      action: {
        disabledBackground: '#a8a8a8',
      },
      background: {
        default: '#000',
      },
      primary: {
        light: '#FFEB3B',
        main: '#FFEB3B',
        dark: '#FFDE2B',
        contrastText: '#000',
      },
      text: {
        secondary: secondaryColor,
      },
    },
    typography: {
      button: {
        fontFamily: '"Pluto Sans Medium", sans-serif',
        fontWeight: 'bold',
        textTransform: 'none',
      },
      fontFamily: '"Pluto Sans Medium", sans-serif',
    },
  });
